import { createStore , applyMiddleware } from "redux";
import rootReducer from "../../reducer";
import {thunk} from "redux-thunk";
import logger from "redux-logger";

const middleware = [thunk, logger];
function configureStore(initialState) {
  return createStore(rootReducer, initialState, applyMiddleware(...middleware));
}

const store = configureStore();
export default store;